module.exports = __webpack_public_path__ + "img/mini-logo.eccf1a3a.png";